<template>
  <section class="About">
    <div class="container">
      <Block7
        :title="blocks.title"
        :figure="blocks.image"
        :content="blocks.content"
        :bg_color="blocks.bg_color"
      />
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import VueI18n from "vue-i18n";

import Block7 from "../shared/blocks/Block7";
import HomeService from "../../domain/HomeService";

export default {
  components: {
    Block7
  },
  watch: {
    "$i18n.locale": function() {
      this.init();
    }
  },
  data() {
    return {
      blocks: []
    };
  },
  methods: {
    init() {
      Vue.http.headers.common["Content-Language"] = this.$i18n.locale;
      this.about.blocks().then(res => {
        this.blocks = res;
        this.blocks = this.blocks[0];
        return this.block;
      });
    }
  },
  created() {
    this.about = new HomeService(this.$resource);
    this.init();
  }
};
</script>

<style lang="scss">
.About {
  background-color: #fff;
  padding: 60px 0;
  border-bottom: 2px solid #e0e0e0;
  text-align: center;

  #block7 {
    p {
      text-align: left;
    }

    .button-storm {
      text-align: center;
    }
  }

  section {
    padding: 0;
  }

  p {
    color: #222831;
    font-size: 1.6em;
    line-height: 24px;
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

@media (max-width: 1024px) {
  .About {
    .container {
      max-width: 100%;
      width: calc(100% - 30px);
      padding: 0 15px;

      article {
        padding: 0;
      }
    }
  }
}

@media (max-width: 640px) {
  .About {
    p {
      text-align: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/About.vue